var map = {
	"./Aggregator.router.js": "1883",
	"./Business.router.js": "f67b",
	"./Discovery.router.js": "25d3",
	"./Home.router.js": "af53",
	"./Individual.router.js": "46c3",
	"./NewAccount.router.js": "ee38",
	"./Public.router.js": "e6d4",
	"./Settings.router.js": "f096",
	"./WorkspacePublic.router.js": "0a28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fe1";